/**
 * Shared date formatting for the Documentation surfaces. One home so the doc
 * list, reader, and PDF builder don't each carry their own `new Date(...)`
 * snippet.
 */

/** The em-dash shown when a document has no detected date. */
export const NO_DATE = "—";

/**
 * Format a document date (ISO 8601 string) for display, locale-aware.
 * Returns `—` for a missing / unparseable value — used for the "Created"
 * column, where a doc with no detected PDF creation date shows a dash.
 */
export function formatDocDate(iso: string | null | undefined): string {
  if (!iso) return NO_DATE;
  const d = new Date(iso);
  return Number.isNaN(d.getTime()) ? NO_DATE : d.toLocaleDateString();
}
